export const BRANCH_RELEASE = true;
export const VERSION = "V.4.0.0";
export const DOMAIN = BRANCH_RELEASE ? `https://shipzo.com` : `http://localhost:3000`;
export const BASE_URL = BRANCH_RELEASE ? `https://shipzo.com` : `http://localhost`;
export const API_URL = `${BASE_URL}/api-shipzo-web/public`;
